import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import LocationMap from "./Modal";
import cImg1 from "../../images/coming.jpg";

const InvitationPage1: React.FC = () => {
  return (
    <Fragment>
      <Navbar hclass="header-style-s2" />
      <section
        className="wpo-invitation-area"
        style={{
          background: `url(${cImg1}) no-repeat center center`,
          backgroundSize: "cover",
        }}
      >
        <div className="hero-container">
          <div className="hero-inner">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div
                    className="wpo-event-wrap wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="wpo-event-item">
                      <div className="wpo-event-text">
                        <h2>Viviana & Ricardo</h2>
                        <p>Nuestra Boda es el 27 de junio de 2026</p>
                        <ul>
                          <li>
                            Sábado 27 de junio de 2026 <br />
                            2:00 PM – 11:00 PM
                          </li>
                          <li>Jardín "Los Faroles"</li>
                          <li>Carretera Federal 113 Xochimilco - Oaxtepec KM 64,200, Tlayacapan, Morelos </li>
                          <li>
                            <LocationMap />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default InvitationPage1;
